import React from "react";
import { createPortal } from "react-dom";

/** Renders children on document.body so fixed overlays aren't trapped by
 *  ancestors with transform/filter/backdrop-filter (e.g. sticky header blur). */
const ModalPortal: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
};

export default ModalPortal;
